<template>
  <div class="language-combinations-list">
       <preloader class="language-combinatioin-preloader"  :preloader-status="filteredLanguagesGroup.length === 0" />
        <div class="search-row">
            <label>
                <span>Search language-combinations:</span>
                <input
                    class="search-row-languages"
                    type="text"
                    v-model="searchRowLanguageGroup"
                    @keypress="languageGroupFilter"
                    @keyup="languageGroupFilter"
                />
            </label>
        </div>

        <table class="default-table">
            <thead>
                <tr>
                    <td class="wd75" >
                       &nbsp;
                    </td>
                    <td class="languagesConfiguration__toggleSort"  @click="toggleSortSourceGroup()">
                        <div class="dsp-fx" >
                            Sourse language
                            <div v-if="sortGroupSourceASC !== null" >
                              <span class="sort-arrow"  v-if="sortGroupSourceASC === true" > ↓ </span>
                              <span class="sort-arrow"  v-if="sortGroupSourceASC === false" > ↑ </span>
                            </div>
                        </div>
                    </td>

                    <td class="wd75" >
                         &nbsp;
                    </td>
                    <td class="languagesConfiguration__toggleSort" @click="toggleSortTargetGroup()" >
                        <div class="dsp-fx">
                            Target language
                            <div v-if="sortGroupTargetASC !== null" >
                              <span class="sort-arrow"  v-if="sortGroupTargetASC === true" > ↓ </span>
                              <span class="sort-arrow"  v-if="sortGroupTargetASC === false" > ↑ </span>
                            </div>
                        </div>
                    </td>

                    <td class="w250" > </td>
                </tr>
                <section></section>
            </thead>
            <tbody>
                <tr v-for="languageGroup in filteredLanguagesGroup" :key="languageGroup.ID">
                   <td class="wd75" >
                        <span :class="['language-active', languageGroup.SourceLanguage.Active ? 'language-active--true' : 'language-active--false']" >
                            {{ languageGroup.SourceLanguage.Active ? 'active' : 'disabled' }}
                        </span>
                    </td>
                    <td class="wd300" >
                        <span
                            v-bind:class="[
                            'language',
                            languageGroup.SourceLanguage.CountryISOCode
                                ? languageGroup.SourceLanguage.CountryISOCode.toLowerCase()
                                : ''
                            ]"
                        ></span>
                            {{ languageGroup.SourceLanguage.LanguageName }}
                    </td>

                    <td class="wd75" >
                        <span :class="['language-active', languageGroup.TargetLanguage.Active ? 'language-active--true' : 'language-active--false']"  >
                            {{ languageGroup.TargetLanguage.Active ? 'active' : 'disabled' }}
                        </span>
                    </td>

                    <td class="wd300" >
                        <span
                            v-bind:class="[
                            'language',
                            languageGroup.TargetLanguage.CountryISOCode
                                ? languageGroup.TargetLanguage.CountryISOCode.toLowerCase()
                                : ''
                            ]"
                        ></span>
                        {{ languageGroup.TargetLanguage.LanguageName }}
                    </td>

                    <td class="w250" >
                        <div class="default-table__btn--wraper">
                            <button
                                class="button btn default-table__btn cl-transparent"
                            >
                                Edit
                            </button>
                            <button
                                class="button btn default-table__btn cl-transparent "
                            >
                                Remove
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <pagination
            v-model="pagination"
            :total="totalItems"
            :options="[6,12,24,36]"
        />

    </div>
</template>

<script>
import Vue from 'vue';
import Api from '@/utils/api';
import debounce from '@/utils/helpers/debounce';
import preloader from '@/components/preloader/index.vue';

const searchDebouncer = debounce();

export default Vue.extend({
  components: {
    pagination: () => import('@/components/paginationSimple/index.vue'),
    preloader,
  },
  data() {
    return {
      languageGroups: [],
      searchRowLanguageGroup: '',
      confirmLanguageGroup: null,
      sortGroupTargetASC: null,
      sortGroupSourceASC: null,
      sortDirAsc: true,
      sortFieldTarget: true,
      filteredLanguagesGroup: [],
      pagination: {
        page: 1,
        ppage: 12,
      },
      totalItems: 1,
    };
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.getLanguageCombinations();
      },
    },
  },
  methods: {
    toggleSortSourceGroup() {
      this.sortGroupSourceASC = !this.sortGroupSourceASC;
      this.sortGroupTargetASC = null;
      this.searchRowLanguageGroup = '';
      this.sortFieldTarget = false;
      this.sortDirAsc = this.sortGroupSourceASC;
      this.getLanguageCombinations();
    },
    toggleSortTargetGroup() {
      this.sortGroupTargetASC = !this.sortGroupTargetASC;
      this.sortGroupSourceASC = null;
      this.searchRowLanguageGroup = '';
      this.sortFieldTarget = true;
      this.sortDirAsc = this.sortGroupTargetASC;
      this.getLanguageCombinations();
    },
    getLanguageCombinations() {
      Api.settings.languageConfiguration
        .getLanguageCombinations(
          this.pagination.page,
          this.pagination.ppage,
          this.sortDirAsc ? 'asc' : 'desc',
          this.sortFieldTarget ? 'target' : 'source',
          this.searchRowLanguageGroup
        )
        .then((res) => {
          if (res.status === 200) {
            this.languageGroups = res.data.Data;
            this.totalItems = res.data.Total;
            this.languageGroupFilter();
          }
        })
        .catch((err) => {
          this.$root.$emit('notification', {
            message: 'Sorry, something went wrong!',
            type: 'error',
            show: true,
          });
        });
    },
    languageGroupFilter() {
      if (this.searchRowLanguageGroup === '') {
        this.filteredLanguagesGroup = this.languageGroups;
        return;
      }
      searchDebouncer(() => {
        this.getLanguageCombinations();
        this.filteredLanguagesGroup = this.languageGroups;
      }, 500);
    },
  },
  created() {
    this.getLanguageCombinations();
  },
});
</script>

<style lang="scss">
.wd75 {
  width: 75px;
}

.w250 {
  width: 250px;
  min-width: 250px;
  max-width: 250px;
}

.wd300 {
  width: 300px;
  min-width: 300px;
  max-width: 300px;
}

.sort-arrow {
  position: absolute;
  font-size: 25px;
  padding: 0 5px;
  margin-top: -5px;
}

.cl-transparent {
  color: transparent;
}

table.default-table {
  thead {
    tr {
      min-height: 55px;
      height: 55px;
    }
  }
}
</style>
